'use client';

import { SessionProvider } from 'next-auth/react';
import SessionDataGuard from './SessionDataGuard';

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider refetchInterval={300} refetchOnWindowFocus>
      <SessionDataGuard>{children}</SessionDataGuard>
    </SessionProvider>
  );
}
